import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pqDateFormat',
    standalone: false
})
export class DateFormatPipe implements PipeTransform {
  public transform (text: string) {
    const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    const dateDataArray = text.split('-');
    const year = dateDataArray[0] || '';
    const day = dateDataArray[2] || '';
    const monthIndex = this.isValid(dateDataArray[1], 2)  ? parseInt(dateDataArray[1], 0) - 1 : '';
    let date = '';

    if (dateDataArray.length === 3) {
      date = monthNames[monthIndex].substr(0, 3) + ' ' + day + ', ' + year ;
    } else if (dateDataArray.length === 2) {
      date = monthNames[monthIndex].substr(0, 3) + ' ' + year ;
    } else if (dateDataArray.length === 1) {
      date = year;
    }

    return date;
  }

  private isValid (text: string, len: number): boolean {
    return (text && text.length === len);
  }
}
